const GRANT_THEMES = {
  2: { color: '#00AEEF', grad: 'linear-gradient(135deg, #00AEEF 0%, #0066b3 100%)' },
  12: { color: '#4361EE', grad: 'linear-gradient(135deg, #4361EE 0%, #3a0ca3 100%)' },
  11: { color: '#1B263B', grad: 'linear-gradient(135deg, #1B263B 0%, #415a77 100%)' },
  10: { color: '#C1121F', grad: 'linear-gradient(135deg, #C1121F 0%, #780000 100%)' },
  9: { color: '#023E8A', grad: 'linear-gradient(135deg, #023E8A 0%, #0077b6 100%)' },
  5: { color: '#CE2939', grad: 'linear-gradient(135deg, #CE2939 0%, #8b0000 100%)' },
  6: { color: '#009246', grad: 'linear-gradient(135deg, #009246 0%, #006622 100%)' },
  13: { color: '#DE2910', grad: 'linear-gradient(135deg, #DE2910 0%, #8b0000 100%)' },
};

const DEFAULT_THEME = {
  color: '#E8192C',
  grad: 'linear-gradient(135deg, #E8192C 0%, #9b1018 100%)',
};

export function getGrantTheme(id) {
  return GRANT_THEMES[id] || DEFAULT_THEME;
}

export function isFeaturedGrant(item) {
  return item?.id === 2 || /болашак/i.test(item?.title || '');
}

export function parseCoversFromHtml(html) {
  if (!html) return [];
  const items = [];
  const re = /<li[^>]*>([\s\S]*?)<\/li>/gi;
  let match = re.exec(html);
  while (match) {
    const text = match[1].replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
    if (text && text.length < 80) items.push(text);
    match = re.exec(html);
  }
  return items.slice(0, 8);
}

export function parseDeadlineFromHtml(html) {
  if (!html) return null;
  const plain = html.replace(/<[^>]+>/g, ' ');
  const match = plain.match(/Дедлайн[:\s]*([^\n.]+)/i);
  return match ? match[1].trim() : null;
}

export function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}
